{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "Crazy Wheel",
  "description": "Уникальная игра в стиле колеса фортуны с разными шансами на выигрыш.",
  "url": "https://6cs.fail/ru/crazy-wheel"
}
